"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var addressTools = _interopRequireWildcard(require("@simplybenefits/sb-address"));
var dates = _interopRequireWildcard(require("@simplybenefits/sb-dates"));
var _Add = _interopRequireDefault(require("@mui/icons-material/Add"));
var _Text = _interopRequireDefault(require("../../components/Text"));
var _TextInput = _interopRequireDefault(require("../../components/TextFields/TextInput"));
var _ = require("../..");
var _Button = _interopRequireDefault(require("../../components/Button"));
var _FormModal = _interopRequireDefault(require("../../components/Modals/FormModal"));
var Services = _interopRequireWildcard(require("../../services"));
var _theme = require("../../theme");
var _Loader = _interopRequireDefault(require("../../components/Loader"));
var _EntityTable = _interopRequireDefault(require("./EntityTable"));
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
var _DisplayBankingDetails = _interopRequireDefault(require("../../components/DisplayBankingDetails"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var DivisionsManagement = /*#__PURE__*/function (_Component) {
  function DivisionsManagement() {
    var _this;
    (0, _classCallCheck2["default"])(this, DivisionsManagement);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, DivisionsManagement, [].concat(args)), _this.state = {
      showNewUser: false,
      currentUser: '',
      showNewDivision: false,
      title: '',
      description: '',
      suite: '',
      firstLine: '',
      city: '',
      province: 'Alberta',
      postalCode: '',
      country: 'Canada',
      selectedDivision: '',
      isDivisionEdit: false,
      eftDetails: null,
      showRemoveModal: false,
      confirmModalOpen: false,
      signage: {
        name: '',
        signature: '',
        acceptedTerms: false,
        timestampOfAcceptance: null,
        datedOn: null
      }
    }, _this.signageRef = /*#__PURE__*/_react["default"].createRef(), _this.accountDetailsRef = /*#__PURE__*/_react["default"].createRef(), _this.componentDidUpdate = function (prevProps, prevState) {
      if (_this.signageRef.current && prevState.eftDetails !== _this.state.eftDetails) {
        _this.signageRef.current.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }, _this._toggleRemoveDivision = function () {
      _this.setState({
        showRemoveModal: !_this.state.showRemoveModal
      });
    }, _this._toggleAddDivision = function () {
      _this.setState({
        showNewDivision: !_this.state.showNewDivision,
        title: '',
        description: '',
        suite: '',
        firstLine: '',
        city: '',
        province: 'Alberta',
        postalCode: '',
        isDivisionEdit: false,
        eftDetails: null,
        showBankingModal: false,
        hasBanking: false,
        signage: {
          name: '',
          signature: '',
          acceptedTerms: false,
          timestampOfAcceptance: null,
          datedOn: null
        }
      });
    }, _this._showConfirmDialog = function () {
      _this.setState({
        confirmModalOpen: !_this.state.confirmModalOpen
      });
    }, _this._handleSignageChange = function (type, value) {
      if (type === 'acceptedTerms' && value === true) {
        _this.setState({
          signage: _objectSpread(_objectSpread({}, _this.state.signage), {}, {
            acceptedTerms: true,
            timestampOfAcceptance: dates.getUTC()
          })
        });
        return null;
      }
      _this.setState({
        signage: _objectSpread(_objectSpread({}, _this.state.signage), {}, (0, _defineProperty2["default"])({}, type, value))
      });
      return null;
    }, _this._validateForm = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var bankingIsValid, signageComplete, titleError, descriptionError, firstLineError, cityError, provinceError, postalCodeError;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(_this.state.eftDetails !== null)) {
              _context.next = 10;
              break;
            }
            bankingIsValid = _this.state.eftDetails["default"].accepted;
            if (bankingIsValid) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return", false);
          case 4:
            _context.next = 6;
            return _this._isSignageCompleted();
          case 6:
            signageComplete = _context.sent;
            if (signageComplete) {
              _context.next = 10;
              break;
            }
            alert(_i18n["default"].t(_tokens["default"].labels.banking.provideSignatureToContinue));
            return _context.abrupt("return", false);
          case 10:
            _context.next = 12;
            return Services.validateInput('divisionName', _this.state.title);
          case 12:
            titleError = _context.sent;
            _context.next = 15;
            return Services.validateInput('checkEmpty', _this.state.description);
          case 15:
            descriptionError = _context.sent;
            _context.next = 18;
            return Services.validateInput('firstLine', _this.state.firstLine);
          case 18:
            firstLineError = _context.sent;
            _context.next = 21;
            return Services.validateInput('city', _this.state.city);
          case 21:
            cityError = _context.sent;
            _context.next = 24;
            return Services.validateInput('province', _this.state.province);
          case 24:
            provinceError = _context.sent;
            _context.next = 27;
            return Services.validateInput('postalCode', _this.state.postalCode);
          case 27:
            postalCodeError = _context.sent;
            if (_this.state.title.length < 1) {
              titleError = _i18n["default"].t(_tokens["default"].labels.classesAndDivisions.divisionTitleRequired);
            } else if (_this.state.title.length > 20) {
              titleError = _i18n["default"].t(_tokens["default"].labels.classesAndDivisions.divisionTitleLength);
            }
            if (_this.state.description && _this.state.description.length > 200) {
              descriptionError = _i18n["default"].t(_tokens["default"].labels.classesAndDivisions.descriptionLengthDivision);
            }
            _this.setState({
              titleError: titleError,
              descriptionError: descriptionError,
              firstLineError: firstLineError,
              cityError: cityError,
              provinceError: provinceError,
              postalCodeError: postalCodeError
            });
            if (!(titleError || descriptionError || firstLineError || cityError || provinceError || postalCodeError)) {
              _context.next = 34;
              break;
            }
            _this.accountDetailsRef.current && _this.accountDetailsRef.current.scrollIntoView({
              behavior: 'smooth'
            });
            return _context.abrupt("return", false);
          case 34:
            return _context.abrupt("return", true);
          case 35:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })), _this._isSignageCompleted = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var _this$state$signage, name, signature, datedOn, signageNameError, signageSignatureError, signageDatedOnError, signageAcceptedError;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _this$state$signage = _this.state.signage, name = _this$state$signage.name, signature = _this$state$signage.signature, datedOn = _this$state$signage.datedOn;
            _context2.next = 3;
            return Services.validateInput('checkEmpty', name);
          case 3:
            signageNameError = _context2.sent;
            _context2.next = 6;
            return Services.validateInput('checkEmpty', signature);
          case 6:
            signageSignatureError = _context2.sent;
            _context2.next = 9;
            return Services.validateInput('date', datedOn, _i18n["default"].locale);
          case 9:
            signageDatedOnError = _context2.sent;
            signageAcceptedError = !_this.state.eftDetails["default"].accepted;
            if (name !== signature) {
              signageNameError = _i18n["default"].t(_tokens["default"].labels.signage.signageNameError);
            }
            if (signageAcceptedError) {
              alert(_i18n["default"].t(_tokens["default"].labels.signage.pleaseAcceptAndAcknowledgeChanges));
            }
            _this.setState({
              signageNameError: signageNameError,
              signageSignatureError: signageSignatureError,
              signageDatedOnError: signageDatedOnError
            });
            if (!(signageNameError || signageSignatureError || signageDatedOnError || signageAcceptedError)) {
              _context2.next = 16;
              break;
            }
            return _context2.abrupt("return", false);
          case 16:
            return _context2.abrupt("return", true);
          case 17:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })), _this._addDivision = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      var isValid, bankingDetails, _this$state, suite, firstLine, city, postalCode, country, province, generatedAddress;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _this._validateForm();
          case 2:
            isValid = _context3.sent;
            if (isValid) {
              _context3.next = 5;
              break;
            }
            return _context3.abrupt("return");
          case 5:
            bankingDetails = null;
            if (_this.state.eftDetails !== null) {
              bankingDetails = {
                accountHolder: _this.state.eftDetails["default"].accountHolder,
                institutionName: _this.state.eftDetails["default"].institutionName,
                institutionAddress: _this.state.eftDetails["default"].institutionAddress,
                institutionNum: _this.state.eftDetails["default"].institutionNum,
                transitNum: _this.state.eftDetails["default"].transitNum,
                accountNum: _this.state.eftDetails["default"].accountNum,
                accepted: _this.state.eftDetails["default"].accepted,
                timestampOfAcceptance: _this.state.eftDetails["default"].timestampOfAcceptance,
                signage: {
                  name: _this.state.signage.name.trim(),
                  signature: _this.state.signage.signature.trim(),
                  acceptedTerms: _this.state.signage.acceptedTerms,
                  timestampOfAcceptance: _this.state.signage.timestampOfAcceptance,
                  datedOn: Services.dates.formatOutgoingDate(_this.state.signage.datedOn)
                }
              };
            }
            _this$state = _this.state, suite = _this$state.suite, firstLine = _this$state.firstLine, city = _this$state.city, postalCode = _this$state.postalCode, country = _this$state.country;
            province = _.localizationMaps.toEnglish("provinces", _this.state.province);
            generatedAddress = addressTools.generateAddress({
              suite: suite,
              firstLine: firstLine,
              city: city,
              province: province,
              postalCode: postalCode,
              country: country
            });
            _context3.next = 12;
            return _this.props.addDivision(_this.state.title.trim(), _this.state.description.trim(), generatedAddress.trim(), bankingDetails, _this.props.currentAccountMeta ? _this.props.currentAccountMeta.accountID : null);
          case 12:
            _this._toggleAddDivision();
          case 13:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })), _this._editDivision = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
      var isValid, bankingDetails, _this$state2, suite, firstLine, city, postalCode, country, province, generatedAddress;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _this._validateForm();
          case 2:
            isValid = _context4.sent;
            if (isValid) {
              _context4.next = 5;
              break;
            }
            return _context4.abrupt("return");
          case 5:
            bankingDetails = null;
            if (_this.state.eftDetails !== null) {
              bankingDetails = {
                accountHolder: _this.state.eftDetails["default"].accountHolder,
                institutionName: _this.state.eftDetails["default"].institutionName,
                institutionAddress: _this.state.eftDetails["default"].institutionAddress,
                institutionNum: _this.state.eftDetails["default"].institutionNum,
                transitNum: _this.state.eftDetails["default"].transitNum,
                accountNum: _this.state.eftDetails["default"].accountNum,
                accepted: _this.state.eftDetails["default"].accepted,
                timestampOfAcceptance: _this.state.eftDetails["default"].timestampOfAcceptance,
                signage: {
                  name: _this.state.signage.name.trim(),
                  signature: _this.state.signage.signature.trim(),
                  acceptedTerms: _this.state.signage.acceptedTerms,
                  timestampOfAcceptance: _this.state.signage.timestampOfAcceptance,
                  datedOn: Services.dates.formatOutgoingDate(_this.state.signage.datedOn)
                }
              };
            }
            _this$state2 = _this.state, suite = _this$state2.suite, firstLine = _this$state2.firstLine, city = _this$state2.city, postalCode = _this$state2.postalCode, country = _this$state2.country;
            province = _.localizationMaps.toEnglish("provinces", _this.state.province);
            generatedAddress = addressTools.generateAddress({
              suite: suite,
              firstLine: firstLine,
              city: city,
              province: province,
              postalCode: postalCode,
              country: country
            });
            _context4.next = 12;
            return _this.props.editDivision(_this.state.title.trim(), _this.state.description.trim(), generatedAddress.trim(), bankingDetails, _this.props.currentAccountMeta ? _this.props.currentAccountMeta.accountID : null, _this.state.selectedDivision, _this.state.hasBanking);
          case 12:
            _this._toggleAddDivision();
          case 13:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    })), _this._openRemoveDivision = function (division) {
      _this.setState({
        showRemoveModal: true,
        title: division.title.trim(),
        description: division.description.trim(),
        selectedDivision: division.divisionID
      });
    }, _this._removeDivision = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
      var success;
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _this.props.removeDivision(_this.state.selectedDivision);
          case 2:
            success = _context5.sent;
            if (success) {
              _this.setState({
                showRemoveModal: false,
                selectedDivision: null
              });
            }
          case 4:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    })), _this._openEditDivision = function (division) {
      var address = '';
      if (division.address) {
        address = addressTools.parseAddress(division.address);
      }
      _this.setState({
        showNewDivision: true,
        title: division.title,
        description: division.description,
        suite: address.suite,
        firstLine: address.firstLine,
        city: address.city,
        province: address.province,
        postalCode: address.postalCode,
        selectedDivision: division.divisionID,
        hasBanking: division.hasBanking,
        isDivisionEdit: true
      });
    }, _this._onBlur = /*#__PURE__*/function () {
      var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(type) {
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.t0 = _this;
              _context6.t1 = _defineProperty2["default"];
              _context6.t2 = {};
              _context6.t3 = "".concat(type, "Error");
              _context6.next = 6;
              return Services.validateInput(type, _this.state[type]);
            case 6:
              _context6.t4 = _context6.sent;
              _context6.t5 = (0, _context6.t1)(_context6.t2, _context6.t3, _context6.t4);
              _context6.t0.setState.call(_context6.t0, _context6.t5);
            case 9:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      return function (_x) {
        return _ref6.apply(this, arguments);
      };
    }(), _this._onAddressBlur = /*#__PURE__*/function () {
      var _ref7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(type) {
        var _this$state3, firstLine, city, province, postalCode;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!(type !== 'suite')) {
                _context7.next = 11;
                break;
              }
              _context7.t0 = _this;
              _context7.t1 = _defineProperty2["default"];
              _context7.t2 = {};
              _context7.t3 = "".concat(type, "Error");
              _context7.next = 7;
              return Services.validateInput(type, _this.state[type]);
            case 7:
              _context7.t4 = _context7.sent;
              _context7.t5 = (0, _context7.t1)(_context7.t2, _context7.t3, _context7.t4);
              _context7.next = 11;
              return _context7.t0.setState.call(_context7.t0, _context7.t5);
            case 11:
              _this$state3 = _this.state, firstLine = _this$state3.firstLine, city = _this$state3.city, province = _this$state3.province, postalCode = _this$state3.postalCode;
              if (!(firstLine && city && province && postalCode)) {
                _context7.next = 15;
                break;
              }
              _context7.next = 15;
              return addressTools.generateAddress(_this.state);
            case 15:
              return _context7.abrupt("return", null);
            case 16:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      return function (_x2) {
        return _ref7.apply(this, arguments);
      };
    }(), _this._handleInputChange = function (type, event, isValue) {
      var value = isValue ? event : event.target.value;
      if (type === 'accepted' && value === true) {
        _this.setState({
          accepted: value,
          acceptedError: false,
          timestampOfAcceptance: dates.getUTC()
        });
      } else {
        _this.setState((0, _defineProperty2["default"])({}, type, value));
      }
    }, _this._handleAddressChange = function (type, event) {
      _this.setState((0, _defineProperty2["default"])({}, type, event.target.value.replace(/,/g, '')));
    }, _this._saveNewBankingDetails = function (newBankingDetails) {
      _this.setState(_objectSpread(_objectSpread({}, _this.state), {}, {
        eftDetails: _objectSpread({}, newBankingDetails),
        hasBanking: true,
        showBankingModal: false
      }));
    }, _this._toggleBankingDetailsModal = function () {
      _this.setState({
        showBankingModal: !_this.state.showBankingModal
      });
    }, (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _inherits2["default"])(DivisionsManagement, _Component);
  return (0, _createClass2["default"])(DivisionsManagement, [{
    key: "render",
    value: function render() {
      var _this2 = this,
        _this$state$eftDetail;
      var _this$state4 = this.state,
        suite = _this$state4.suite,
        firstLine = _this$state4.firstLine,
        city = _this$state4.city,
        province = _this$state4.province,
        postalCode = _this$state4.postalCode;
      var styles = {
        modalFlex: {
          display: 'flex',
          alignItems: 'flex-start',
          flexDirection: 'column'
        },
        customContainerStyle: {
          // minHeight: 400,
          maxWidth: "500px"
        },
        contentBlock: _theme.globalStyles.contentBlock,
        contentMargin: _theme.globalStyles.contentMargin,
        form: _theme.globalStyles.form,
        title: _theme.globalStyles.title,
        titleBlock: {
          display: 'flex',
          alignItems: 'center',
          marginBottom: '10px'
        },
        row: {
          display: 'flex',
          flexDirection: 'row'
        },
        divider: {
          width: '40px'
        }
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '50px'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.titleBlock
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        large: true,
        bold: true
      }, _i18n["default"].t(_tokens["default"].labels.admin.divisions)), (this.props.step <= 3 || this.props.isMasterSite) && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        transparent: true,
        onClick: this._toggleAddDivision,
        customStyle: {
          marginLeft: 'auto'
        }
      }, /*#__PURE__*/_react["default"].createElement(_Add["default"], {
        style: {
          fontSize: 17,
          lineHeight: '14px',
          color: 'inherit'
        }
      }), "\xA0", _i18n["default"].t(_tokens["default"].buttons.createDivision))), /*#__PURE__*/_react["default"].createElement(_EntityTable["default"], {
        items: this.props.divisions,
        edit: !this.props.isMasterSite && this.props.step >= 4 ? null : this._openEditDivision,
        remove: !this.props.isQuote ? null : !this.props.isMasterSite && this.props.step >= 4 ? null : this._openRemoveDivision,
        language: this.props.language || "en"
      }), /*#__PURE__*/_react["default"].createElement(_FormModal["default"], {
        open: this.state.showRemoveModal,
        close: this._toggleRemoveDivision,
        title: _i18n["default"].t(_tokens["default"].labels.classesAndDivisions.removeDivision),
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
        onSave: this._removeDivision,
        saveButtonText: _i18n["default"].t(_tokens["default"].labels.classesAndDivisions.removeDivision),
        customContainerStyle: {
          maxWidth: "500px"
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        light: true
      }, _i18n["default"].t(_tokens["default"].labels.classesAndDivisions.removalConfirmationDivision), " ", /*#__PURE__*/_react["default"].createElement("b", null, this.state.title), _i18n["default"].t(_tokens["default"].labels.classesAndDivisions.allDataForDivisionLost)), this.props.loading && /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
        whitelabel: this.props.whitelabel,
        customImageStyle: {
          top: '50%'
        }
      })), /*#__PURE__*/_react["default"].createElement(_FormModal["default"], {
        open: this.state.showNewDivision,
        close: this._toggleAddDivision,
        title: this.state.isDivisionEdit ? _i18n["default"].t(_tokens["default"].titles.editDivision) : _i18n["default"].t(_tokens["default"].titles.newDivision),
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
        onSave: this.state.isDivisionEdit ? this._editDivision : this._addDivision,
        customContainerStyle: {
          maxWidth: "500px"
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.accountDetailsRef
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.classesAndDivisions.title),
        value: this.state.title,
        onChange: function onChange(value) {
          return _this2._handleInputChange('title', value);
        },
        error: Boolean(this.state.titleError),
        helperText: this.state.titleError,
        fullWidth: true,
        autofocus: true
      }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.classesAndDivisions.description),
        value: this.state.description,
        onChange: function onChange(value) {
          return _this2._handleInputChange('description', value);
        },
        error: Boolean(this.state.descriptionError),
        helperText: this.state.descriptionError,
        fullWidth: true,
        autofocus: true
      }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.streetAddress),
        value: firstLine,
        onBlur: function onBlur() {
          return _this2._onAddressBlur('firstLine');
        },
        onChange: function onChange(value) {
          return _this2._handleAddressChange('firstLine', value);
        },
        error: Boolean(this.state.firstLineError),
        helperText: this.state.firstLineError,
        fullWidth: true
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.row
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.account.suiteUnit),
        value: suite,
        onBlur: function onBlur() {
          return _this2._onAddressBlur('suite');
        },
        onChange: function onChange(value) {
          return _this2._handleAddressChange('suite', value);
        },
        fullWidth: true
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.divider
      }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.account.cityTown),
        value: city,
        onBlur: function onBlur() {
          return _this2._onAddressBlur('city');
        },
        onChange: function onChange(value) {
          return _this2._handleAddressChange('city', value);
        },
        error: Boolean(this.state.cityError),
        helperText: this.state.cityError,
        fullWidth: true
      })), /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.row
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.province),
        value: _.localizationMaps.fromEnglish("provinces", province) || 'Alberta',
        onBlur: function onBlur() {
          return _this2._onAddressBlur('province');
        },
        onChange: function onChange(value) {
          return _this2._handleInputChange('province', value);
        },
        select: true,
        selectOptions: Services.selectFieldOptions.provinceOptions(),
        fullWidth: true
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.divider
      }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.postalCode),
        value: postalCode,
        onBlur: function onBlur() {
          return _this2._onAddressBlur('postalCode');
        },
        onChange: function onChange(value) {
          return _this2._handleAddressChange('postalCode', value);
        },
        error: Boolean(this.state.postalCodeError),
        helperText: this.state.postalCodeError,
        fullWidth: true
      }))), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: function onClick() {
          return _this2._toggleBankingDetailsModal();
        },
        customStyle: {
          width: "100%"
        },
        marginTop: "20px",
        marginBottom: "5px",
        transparent: true
      }, this.state.showBankingModal ? 'Close' : this.state.hasBanking || this.state.eftDetails ? _i18n["default"].t(_tokens["default"].labels.banking.override) : _i18n["default"].t(_tokens["default"].buttons.add), " ", _i18n["default"].t(_tokens["default"].buttons.bankingDetails)), this.state.eftDetails && /*#__PURE__*/_react["default"].createElement(_DisplayBankingDetails["default"], {
        accountHolder: this.state.eftDetails["default"].accountHolder,
        accountNum: this.state.eftDetails["default"].accountNum,
        institutionAddress: this.state.eftDetails["default"].institutionAddress,
        institutionName: this.state.eftDetails["default"].institutionName,
        institutionNum: this.state.eftDetails["default"].institutionNum,
        transitNum: this.state.eftDetails["default"].transitNum,
        accepted: this.state.eftDetails["default"].accepted
      }), (_this$state$eftDetail = this.state.eftDetails) !== null && _this$state$eftDetail !== void 0 && (_this$state$eftDetail = _this$state$eftDetail["default"]) !== null && _this$state$eftDetail !== void 0 && _this$state$eftDetail.accepted ? /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.signageRef
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.yourName),
        fullWidth: true,
        value: this.state.signage.name,
        onChange: function onChange(e) {
          return _this2._handleSignageChange('name', e.target.value);
        },
        error: this.state.signageNameError
      }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.signature),
        fullWidth: true,
        value: this.state.signage.signature,
        onChange: function onChange(e) {
          return _this2._handleSignageChange('signature', e.target.value);
        },
        isSignature: true,
        error: this.state.signageSignatureError
      }), /*#__PURE__*/_react["default"].createElement(_.DateInput, {
        label: _i18n["default"].t(_tokens["default"].labels.account.datedOnYYYYMMDD),
        fullWidth: true,
        value: this.state.signage.datedOn,
        onChange: function onChange(e) {
          return _this2._handleSignageChange('datedOn', e.target.value);
        },
        error: this.state.signageDatedOnError
      })) : null, this.props.loading && /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
        whitelabel: this.props.whitelabel,
        customImageStyle: {
          top: '50%'
        }
      })), this.state.showBankingModal && /*#__PURE__*/_react["default"].createElement(_.EditBankingDetails, {
        validateBankingDetails: this.props.validateBankingDetails,
        bankingDetailsVerifying: this.props.bankingDetailsVerifying,
        whitelabel: this.props.whitelabel,
        saveNewBankingDetails: this._saveNewBankingDetails,
        accountLevelBankingDetailsView: true,
        close: function close() {
          return _this2._toggleBankingDetailsModal();
        },
        customModalWidth: 500
      }), /*#__PURE__*/_react["default"].createElement("span", {
        id: "divisions-card"
      }));
    }
  }]);
}(_react.Component);
var _default = exports["default"] = DivisionsManagement;